export enum submissionType{
    'CTOP' = 0,
    'Energy' = 1,
    'WRAP' = 2,
    'HSHM' = 3,
    'Reverse Mortage ACQ' = 4,
    'Servicing' = 5,
    'Trial Balance' = 6,
    'Servicing Transfer' = 7,
    'Servicing eBoutique' = 8,
    'PREMIUM GRID UPLOAD' = 9
}
